import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { PortfolioImportHoldingsDialogComponent } from '@irb/irb-create-portfolio/portfolio-import-holdings-dialog/portfolio-import-holdings-dialog.component';
import { UtilityService } from '@irb-common/services/utility.service';

@Injectable({
    providedIn: 'root'
})
export class PortfolioImportHoldingsGridLayoutService implements GridLayoutService<PortfolioImportHoldingsDialogComponent> {
    constructor(private util: UtilityService) {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs(_parent: PortfolioImportHoldingsDialogComponent) {
        return [{
                    headerName: 'Account Number',
                    field: 'accountNumber',
                    maxWidth: 150,
                    width: 150,
                    sort:'asc'
                },
                {
                    headerName: 'Account Name',
                    field: 'accountName',
                    minWidth: 401,
                    maxWidth: 401
                },
                {
                    headerName: 'Account Type',
                    field: 'accountType',
                    minWidth: 140
                }];
    }
}
